import {useState, useContext, useEffect} from 'react';
import styles from '../Applicants/css/display-applicant.module.css';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import apiCall from '../../../utils/apiCall';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import { FilterDropDown,DateFilter} from '../../../ui-components';
import UploadOffLinePaymentTable from './Table';
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../utils/allRouteId';
import { useSelector } from 'react-redux';
import {RootState} from '../../../redux/store';
import { NotificationContext } from '../../../providers/notification'; 
import {RouteResponse} from '../../../types/index';
import {FetchAllRoutes, reOrderFetchedData} from '../../../hooks/FetchData'


// Interfaces
interface UploadOffLinePaymentItem {
  SN: number;
  PaymentHistoryId: number;
  ApplicantId: string;
  FullName: string;
  CustomerEmail: string;
  CustomerPhone: string;
  PaymentChannel: string;
  PaymentDate: string;
  Amount: number;
  RouteName: string;
  RouteId: number;
  PaymentReference: string;
  PaymentStatus: string;
  PaymentAction: string;
  RecieptUrl: string;
}

interface Route {
  name: string;
  val: number;
}

interface DisplayUploadOffLinePaymentProps {
  setRoute: React.Dispatch<React.SetStateAction<Route>>;
  route?: Route;
}

const DisplayUploadOffLinePayment = ({ setRoute, route }: DisplayUploadOffLinePaymentProps) => {
  const [searchData, setSearchData] = useState("");
  const [routeNameInt, setRouteNameInt] = useState("");
  const { showNotification } = useContext(NotificationContext);

  // Fetch offline payments based on route
  const {
    data: uploadedPayments = [],
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<UploadOffLinePaymentItem[], AxiosError>(
    ["upload-payment-history", route?.val],
    async () => {
      const response = await apiCall().get("Payment/GetAllPaymentHistory", {
        params: {
          paymentAction: "",
          PageNumber: 1,
          PageSize: 100,
          paymentChannel: "Deposit",
          routeId: route?.val, // include if backend supports filtering by route
        },
      });
      return response.data.reportItems || [];
    },
    {
      enabled: !!route?.val, // only fetch when route is selected
    }
  );

  const handleRouteSwitch = (newRoute: Route) => {
    setRoute(newRoute);
    setRouteNameInt(newRoute.name);
  };

  // Optimized filtering by key fields
  const filteredData =
    searchData.trim().length > 0
      ? uploadedPayments.filter((item) =>
          [item.ApplicantId, item.FullName, item.CustomerEmail, item.CustomerPhone, item.PaymentReference]
            .filter(Boolean)
            .some((val) => val.toLowerCase().includes(searchData.toLowerCase()))
        )
      : uploadedPayments;

  return (
    <>
      <div className={styles.topWrapper}>
        <label className={styles.searchForm}>
          <span className={styles.sI}>
            <SearchIcon />
          </span>
          <input
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
            type="text"
            placeholder="Search"
          />
          <button className={styles.rBtn} type="button" onClick={() => refetch()}>
            <ReloadIcon />
          </button>
        </label>
      </div>

      {isLoading ? (
        <CircularProgress
          sx={{
            fontSize: "1rem",
            marginInline: "auto",
            display: "block",
            marginBlock: "2rem",
          }}
        />
      ) : isError ? (
        <div className={styles.error}>{error?.message || "Error fetching payments"}</div>
      ) : filteredData.length > 0 ? (
        <UploadOffLinePaymentTable data={filteredData} routeId={route?.val} />
      ) : (
        <div>No Result</div>
      )}
    </>
  );
};

export default DisplayUploadOffLinePayment;



const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const TopWrapper = styled('div')`
  display:flex;
  gap:10px;
  align-items: center;
  margin: 10px 0px 48px 0px;
`
